import { PIAPI } from '@core/base';
import { CreateTaskRequest, TaskResponse, HailuoTaskOutput } from '@core/types';
import { HailuoConfig, HailuoVideoParams } from './types';

export class HailuoAPI extends PIAPI {
  private config: HailuoConfig;

  constructor(apiKey: string, config: HailuoConfig = {}, baseUrl?: string) {
    super(apiKey, baseUrl);
    this.config = config;
  }

  private validateImageUrl(imageUrl?: string) {
    if (!imageUrl) return;

    // Add URL format validation if needed
    const url = new URL(imageUrl);
    const extension = url.pathname.split('.').pop()?.toLowerCase();

    if (!extension || !['jpg', 'jpeg', 'png'].includes(extension)) {
      throw new Error('Image URL must point to a JPG or PNG file');
    }
  }

  private createHailuoRequest(params: HailuoVideoParams): CreateTaskRequest {
    // Validate prompt length
    if (params.prompt && params.prompt.length > 2000) {
      throw new Error('Prompt must not exceed 2000 characters');
    }

    // Validate image URL if present
    this.validateImageUrl(params.image_url);

    const request: CreateTaskRequest = {
      model: 'hailuo',
      task_type: 'video_generation',
      input: {
        ...params,
      },
      config: {
        service_mode: 'public',
      },
    };

    if (this.config.webhookUrl && this.config.webhookSecret) {
      request.config = {
        ...request.config,
        webhook_config: {
          endpoint: this.config.webhookUrl,
          secret: this.config.webhookSecret,
        },
      };
    }

    return request;
  }

  async generateVideo(
    params: HailuoVideoParams
  ): Promise<TaskResponse<HailuoTaskOutput>> {
    const request = this.createHailuoRequest(params);
    return this.createTask<HailuoTaskOutput>(request);
  }

  async getVideoTask(taskId: string): Promise<TaskResponse<HailuoTaskOutput>> {
    return this.getTask<HailuoTaskOutput>(taskId);
  }
}
